exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-2f9f5286]:export {\n  xrColorPrimary: #2362FB;\n}\n.el-input-number[data-v-2f9f5286] {\n  width: 100%;\n}\n.el-input-number[data-v-2f9f5286] .el-input__inner {\n    text-align: left;\n    padding: 0 8px;\n}\n", ""]);

// exports
